export function FrameTest() {
    return (
        <iframe src="https://mywallet.testnet.loginid.io/cookie" height="240" title="LoginID iFrame Test">
        </iframe>
    )
}
